import React, { useEffect, useState } from "react";
import {
  StyledSelectContent,
  StyledSelectWrapper,
  StyledSpinnerWrapper,
} from "../styles/styledComponents";

import Button from "./Button";
import ColorRadioGroup from "./ColorRadioGroup";
import "../styles/selectWrapper.css";
import colors from "../styles/colors";
import Color from "../types/Color";
import { useSelectedContextState } from "../context/selectedContext";
import { CircularProgress } from "@mui/material";
import {useTranslation} from "react-i18next";
import CheckIcon from "./CheckIcon";

type ColorSelectWrapperProps = {
  colorItems: Color[];
  selected: (value: string) => any;
  clickNext: () => any;
  countryCode?: string;
};

const ColorSelectWrapper = (props: ColorSelectWrapperProps) => {
  const { colorItems, selected, clickNext, countryCode } = props;
  const [selectedValue, setSelectedValue] = useState("");
  const [state] = useSelectedContextState();
  const { clearAll, colorLoading, clearChildrenStates } = state;
  const {t} = useTranslation('trans');

  const onSelected = (value: any) => {
    setSelectedValue(value);
    selected(value);
  };

  useEffect(() => {
    if (clearAll || clearChildrenStates) {
      setSelectedValue("");
    }
  }, [clearAll, clearChildrenStates]);

  return (  
      <StyledSelectWrapper
        className={selectedValue ? "triangleSelected" : "triangleUnSelected"}
        style={{
          background: selectedValue ? colors.selectedBg : colors.unSelectedBg,
          borderColor: selectedValue
            ? colors.selectedBorder
            : colors.unSelectedBorder,
        }}
      >
        <StyledSelectContent role="radiogroup" aria-labelledby="colorHeader">
          <h2 id="colorHeader">
            {t('selectTitles.color')}
            <CheckIcon size="sm" display={selectedValue !== ""} />
            </h2>
            <p style={{paddingBottom: '20px'}}>{t('colors.description')}</p>
          <div style={{ marginBottom: "60px" }}>
            {colorLoading ? (
              <StyledSpinnerWrapper>
                <CircularProgress color="inherit" />
               {t('loading')}
              </StyledSpinnerWrapper>
            ) : (
              <ColorRadioGroup selected={onSelected} radioValues={colorItems} countryCode={countryCode} />
            )}
          </div>
          {/* <Button
            disabled={!selectedValue}
            text={t('buttons.next')}
            onClick={() => clickNext}
          /> */}
        </StyledSelectContent>
      </StyledSelectWrapper>
  );
};

export default ColorSelectWrapper;
